export type SearchByType = 0 | 1 | 2 | 3

export enum SearchBy {
  Beats = 0,
  Beatmakers = 1,
  Tags = 2,
  StylesAndMoods = 3
}

export enum PhotoType {
  ProPageWallpaperRu = 19,
  ProPageWallpaperEng = 20,
  ProPageWallpaperLogoRu = 21,
  ProPageWallpaperLogoEng = 22,
  ProPageHeaderLogoRu = 23,
  ProPageFooterLogoRu = 24,
  ProPageHeaderLogoEng = 25,
  ProPageFooterLogoEng = 26,
  ProPageFaviconRu = 27,
  ProPageFaviconEng = 28
}

export enum EmailSourceType {
  OwnSite = 0,
  BeatmakersTV = 1,
  ProducerPage = 2,
  BeatmakerTV = 3
}

export enum PaymentSources {
  None = 0,
  BeatmakerTV = 1,
  BeatmakersTV = 2,
  ProducerPage = 3,
  Widget = 4
}

export enum CompilationTypes {
  CatalogBeats = 0,
  Spotlight = 1,
  ChartToppers = 2,
  TopDaySeller = 3,
  HotNewBeats = 4,
  EditorChoice = 5,
  Favorites = 6
}

export enum BeatsSortBy {
  Date = 0,
  OrderNumber = 1,
  ChartTop = 2
}

export enum FreeBeatsSortBy {
  AddedDateDesc = 0,
  AddedDateAsc = 1,
  DownloadsDesc = 6,
  DownloadsAsc = 7
}

export type SortBy = BeatsSortBy | FreeBeatsSortBy

export enum Roles {
  ADMINISTRATOR = 'ADMINISTRATOR',
  BEATMAKER = 'BEATMAKER',
  PROMO_VIEWER = 'PROMO_VIEWER',
  COMPILATIONS_MANAGER = 'COMPILATIONS_MANAGER',
  SUBSCRIPTION_MANAGER = 'SUBSCRIPTION_MANAGER',
  TEMPLATE_MANAGER = 'TEMPLATE_MANAGER',
  SHOPS_MANAGER = 'SHOPS_MANAGER',
  PAYMENTS = 'PAYMENTS',
  EXPERT = 'EXPERT'
}
